import createDataContext from './createDataContext';
import * as actions from './actions/vesselMediaFileActions';
import { reducer, initialState } from './reducers/vesselMediaFileReducer';

export const { Context: VesselMediaFileContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
